import React from "react"
import * as vars from "./vars"

export function Version() {
  const version = vars.version
  const date = vars.date
  const title = `v${version} ${date}`

  function onClick() {
    alert(title)
  }

  return (
    <div style={style} title={title} onClick={onClick}>
      v{version}
    </div>
  )
}

const style: React.CSSProperties = {
  opacity: 0.3,
  fontSize: 9,
  fontFamily: "monospace",
  textAlign: "center",
  color: "black",
  cursor: "default",
  userSelect: "none",
}
